module.exports = __webpack_public_path__ + "img/p_snow.222db0d9.jpg";